<template>
  <div
    data-testid="license-deactivate-container"
    class="wrapper shadowboxing"
  >
    <div
      data-testid="license-deactivate--title"
      class="main-label ibf-h2"
    >
      {{ isUnix ? $t('license.deactivate.linux.title') : $t('license.deactivate.windows.title') }}
    </div>
    <div
      data-testid="license-deactivate--subtitle"
      class="body-text ibf-text-list3 app_text_grey"
    >
      {{ isUnix ? $t('license.deactivate.linux.subtitle') : $t('license.deactivate.windows.subtitle') }}
    </div>
    <q-btn
      data-testid="deactivate-button"
      v-if="!isLicenseOffline"
      rounded
      no-caps
      flat
      class="incredi-button-ibx secondary ibf-button1 danger pull-right"
      @click="deactivate()"
      >{{ isUnix ? $t('license.deactivate.linux.button') : $t('license.deactivate.windows.button') }}</q-btn
    >
  </div>
</template>

<script>
export default {
  name: 'LicenseDeactivate',
  model: {
    events: ['deactivate'],
  },
  props: {
    isLicenseOffline: { type: Boolean },
    isUnix: { type: Boolean, required: true },
  },
  methods: {
    deactivate() {
      this.$emit('deactivate');
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  padding: 20px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .main-label {
    margin: 4px 0 10px 0;
  }
  & .pull-right {
    align-self: flex-end;
  }
  .body-text {
    margin-bottom: auto;
  }
}
</style>
